// components/ParentGroup.tsx
import React from "react";
import SubjectRow from "./SubjectRow";
import { useTranslation } from "react-i18next";
import { getSubjectLabelFromCode } from "utils/schoolUtils";

type Props = {
    parentGroup: {
        parentId: string;
        parent: any | null;
        items: any[];
    };
    onDelete: (id: string) => void;
};

const ParentGroup: React.FC<Props> = ({ parentGroup: pg, onDelete }) => {
    const { t } = useTranslation();

    return (
        <div className="mb-3" key={pg.parentId}>
            {pg.parentId !== "no_parent" && (
                <div className="d-flex align-items-center mb-3">
                    {/* Colored dot */}
                    <span
                        style={{
                            display: "inline-block",
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            backgroundColor: pg.parent?.colorCode || "#999",
                            marginRight: 10,
                        }}
                    />

                    {/* Title text */}
                    <span
                        className="fw-bold text-uppercase"
                        style={{
                            fontSize: "1rem",
                            letterSpacing: "0.5px",
                            color: "#333",
                        }}
                    >
                        {getSubjectLabelFromCode(pg.parent?.code, t) || pg.parent?.name}
                    </span>

                    {/* Divider line */}
                    <div
                        style={{
                            flex: 1,
                            height: 1,
                            backgroundColor: "#e0e0e0",
                            marginLeft: 12,
                        }}
                    />
                </div>
            )}


            {/* Columns header */}
            <div className="row fw-600 mb-2">
                <div className="col-6">{t("subject")}</div>
                <div className="col-2">{t("coefficient")}</div>
                <div className="col-2">{t("class_level_subject_setting.allowed_hours")}</div>
                <div className="col-2">{t("actions")}</div>
            </div>

            {/* Children rows */}
            {pg.items.map((item: any) => (
                <SubjectRow key={item.id} item={item} onDelete={onDelete} />
            ))}
        </div>
    );
};

export default ParentGroup;
